import { createContext } from '@chakra-ui/react-utils';

import type { MenuButtonProps } from '../MenuButton';

export type MenuContextValue = Pick<MenuButtonProps, 'size'>;

const [MenuProvider, useMenuContext] = createContext<MenuContextValue>({
  name: 'MenuContext',
  errorMessage:
    'useMenuContext: `context` is undefined. Seems you forgot to wrap all menu components within `<Menu />`',
});

export { MenuProvider, useMenuContext };
